import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SwUpdate } from '@angular/service-worker';
import { environment } from 'src/environments/environments';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private readonly apiUrl = environment.apiUrl + '/v1/gasprecio/versions';
  private readonly localKey = 'appVersionGaspre';

  constructor(private http: HttpClient, private swUpdate: SwUpdate) { }

  checkVersion(): void {
    this.http.get<any>(this.apiUrl).subscribe({
      next: (response: any) => {
        const currentVersion = response.version.toString();
        const localVersion = localStorage.getItem(this.localKey);

        if (localVersion !== currentVersion) {
          console.warn(`Versión desactualizada. Local: ${localVersion}, Backend: ${currentVersion}`);
          this.clearCachesAndReload();
        } else {
          console.info('Versión actualizada. Todo OK ✅');
        }

        // Siempre actualizá el valor guardado
        localStorage.setItem(this.localKey, currentVersion);
      },
      error: (err) => {
        console.error('Error verificando versión:', err);
      }
    });

    // (Opcional) para PWA con ServiceWorker
    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        console.log('Actualización disponible via Service Worker. Recargando...');
        window.location.reload();
      });
    }
  }

  private clearCachesAndReload(): void {
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => caches.delete(name));
      });
    }

    window.location.reload();
  }
}